import { useOutletContext, useParams, useLocation } from 'react-router-dom';
import CategoryProducts from '../components/CategoryProducts';
import { useEffect, useState } from 'react';

const CategoryProductsPage = () => {
  const { categoryId } = useParams();
  const location = useLocation();
  const [localProducts, setLocalProducts] = useState([]);
  const [localCategory, setLocalCategory] = useState(null);
  const { closeCategoriesDropdown } = useOutletContext();
      const {
        handleCategoryClick,
        cart,
        setCart,
        isLoggedIn,
        refreshCart
      } = useOutletContext();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {

    window.scrollTo(0, 0);
  }, [closeCategoriesDropdown]);

  const fetchCategoryProducts = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/ewe/products/category/${id}`);
      if (!response.ok) throw new Error('Failed to fetch products');
      const data = await response.json();
      setLocalProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
      setLocalProducts([]);
    }
  };

  useEffect(() => {
    if (location.state?.categoryProducts) {
      setLocalProducts(location.state.categoryProducts);
      setLocalCategory(location.state.selectedCategory);
    } else {
      fetchCategoryProducts(categoryId);
    }
  }, [categoryId, location.state]);

  return (
    <div className="category-products-page">
      <CategoryProducts
        products={localProducts}
        categoryName={localCategory?.name}
        handleCategoryClick={handleCategoryClick}
        subcategories={localCategory?.children || []}
        cart={cart}
        setCart={setCart}
        isLoggedIn={isLoggedIn}
        refreshCart={refreshCart}
      />
    </div>
  );
};

export default CategoryProductsPage;